window.formValidation = function formValidation(formData) {
  if (!document.querySelector('.portal')) {
    try {
      console.log(formData);
      const data =
        typeof formData === 'string' ? JSON.parse(formData) : formData;
      console.log(data);

      const formId = data.form_id;
      const errorMessages = data.names;

      let formErrorMessage = '';
      let fieldErrors = {};

      if (
        data?.names &&
        Array.isArray(data.names) &&
        Array.isArray(data.names[0]) &&
        typeof data.names[0][0] === 'string'
      ) {
        formErrorMessage = data.names[0][0];
      } else if (
        data?.names &&
        typeof data.names === 'object' &&
        !Array.isArray(data.names)
      ) {
        fieldErrors = data.names;
      }

      const defaultOptions = {
        errorTextClasses: 'text-red-500',
        errorTextClassesCheckRadio: 'text-red-500 absolute bottom-0 left-0',
        errorTextClassesFile: 'text-red-500',
        errorTextClassesSelect: 'text-red-500',
        inputErrorClasses: '!border-red-400',
        selectErrorClasses: '!border-red-400',
        errorTextClassesForm: 'text-red-500',
        defaultErrorMessage: 'This field is required',
        errorClearDelay: 500,
        transitionDelay: 300,
      };

      const finalOptions = { ...defaultOptions };
      const errors = {};

      const form = document.getElementById(formId);
      if (!form) {
        throw new Error(`Form with ID "${formId}" not found.`);
      }

      if (formErrorMessage && formErrorMessage !== '') {
        let formErrorElement = form.querySelector('.form-error-text');
        if (formErrorElement) {
          formErrorElement.remove();
        }

        formErrorElement = document.createElement('div');
        formErrorElement.className = `form-error-text ${finalOptions.errorTextClassesForm}`;
        formErrorElement.textContent = formErrorMessage;

        form.classList.add('error');
        form.appendChild(formErrorElement);
        /*form.insertBefore(formErrorElement, form.firstChild);*/

        console.log(form);

        if (form.querySelector('input, textarea')) {
          const inputs = form.querySelectorAll('input, textarea');
          inputs.forEach((input) => {
            input.addEventListener('click', () => {
              form.classList.remove('error');
            });

            input.addEventListener('change', () => {
              form.classList.remove('error');
            });
          });
        }
      }

      if (
        errorMessages &&
        (typeof errorMessages !== 'object' || Array.isArray(errorMessages))
      ) {
        throw new Error('Invalid error format. Expected an object.');
      }

      if (errorMessages) {
        Object.keys(errorMessages).forEach((fieldName) => {
          const inputField = form.elements[fieldName];
          if (!inputField) {
            console.warn(`Input field "${fieldName}" not found in form.`);
            return;
          }

          const fieldValue = inputField.value.trim();
          const parentElement = inputField.parentElement;
          const isCheckboxOrRadio =
            inputField.type === 'checkbox' || inputField.type === 'radio';
          const isFile = inputField.name === 'cv_field';
          const isSelect = inputField.tagName.toLowerCase() === 'select';

          const errorMessage =
            errorMessages[fieldName]?.[0] || finalOptions.defaultErrorMessage;

          const errorTextClass = isFile
            ? finalOptions.errorTextClassesFile
            : isCheckboxOrRadio
            ? finalOptions.errorTextClassesCheckRadio
            : isSelect
            ? finalOptions.errorTextClassesSelect
            : finalOptions.errorTextClasses;

          let errorTextElement = isSelect
            ? parentElement.parentElement.parentElement.querySelector(
                '.error-text'
              )
            : parentElement.querySelector('.error-text');

          if (!isCheckboxOrRadio && !isFile && !isSelect) {
            errors[fieldName] = errorMessage;

            inputField.classList.add(
              'error',
              ...finalOptions.inputErrorClasses.split(' ')
            );

            if (!errorTextElement) {
              errorTextElement = document.createElement('span');
              errorTextElement.className = `error-text ${errorTextClass}`;
              parentElement.appendChild(errorTextElement);

              errorTextElement.addEventListener('click', () => {
                const metaParentEl =
                  errorTextElement.closest("[class^='meta-']");
                const errorParentElement = errorTextElement.closest('.error');

                if (errorParentElement) {
                  errorParentElement.classList.remove('error');
                }

                if (metaParentEl) {
                  const errorsElArr = metaParentEl.querySelectorAll('.error');
                  for (let i = 0; i < errorsElArr.length; i++) {
                    errorsElArr[i].classList.remove('error');
                  }

                  const inputClassesToRemove =
                    defaultOptions.inputErrorClasses.split(' ');
                  const selectClassesToRemove =
                    defaultOptions.selectErrorClasses.split(' ');

                  const fields = metaParentEl.querySelectorAll(
                    'input, select, textarea, .choices__inner'
                  );

                  fields.forEach((field) => {
                    inputClassesToRemove.forEach((cls) =>
                      field.classList.remove(cls)
                    );
                    selectClassesToRemove.forEach((cls) =>
                      field.classList.remove(cls)
                    );
                  });
                }
              });
            } else {
              if (errorTextElement) {
                errorTextElement.addEventListener('click', () => {
                  const metaParentEl =
                    errorTextElement.closest("[class^='meta-']");
                  const errorParentElement = errorTextElement.closest('.error');

                  if (errorParentElement) {
                    errorParentElement.classList.remove('error');
                  }

                  if (metaParentEl) {
                    const errorsElArr = metaParentEl.querySelectorAll('.error');
                    for (let i = 0; i < errorsElArr.length; i++) {
                      errorsElArr[i].classList.remove('error');
                    }

                    const inputClassesToRemove =
                      defaultOptions.inputErrorClasses.split(' ');
                    const selectClassesToRemove =
                      defaultOptions.selectErrorClasses.split(' ');

                    const fields = metaParentEl.querySelectorAll(
                      'input, select, textarea, .choices__inner'
                    );

                    fields.forEach((field) => {
                      inputClassesToRemove.forEach((cls) =>
                        field.classList.remove(cls)
                      );
                      selectClassesToRemove.forEach((cls) =>
                        field.classList.remove(cls)
                      );
                    });
                  }
                });
              }
            }
            errorTextElement.textContent = errorMessage;
          } else if (!isCheckboxOrRadio && !isFile && !isSelect) {
            inputField.classList.remove(
              'error',
              ...finalOptions.inputErrorClasses.split(' ')
            );

            if (errorTextElement) {
              setTimeout(() => {
                parentElement.removeChild(errorTextElement);
              }, finalOptions.transitionDelay + finalOptions.errorClearDelay);
            }
          } else if (isCheckboxOrRadio || isFile || isSelect) {
            errors[fieldName] = errorMessage;

            inputField.classList.add('error');

            if (isCheckboxOrRadio || isFile) {
              parentElement.classList.add('error');
            } else if (isSelect) {
              const selectParent = parentElement.parentElement;
              selectParent.classList.add(
                'error',
                ...finalOptions.selectErrorClasses.split(' ')
              );
            }

            if (!errorTextElement) {
              errorTextElement = document.createElement('span');
              errorTextElement.className = `error-text ${errorTextClass}`;

              if (isFile) {
                parentElement.insertAdjacentElement(
                  'afterend',
                  errorTextElement
                );
              } else if (isSelect) {
                const selectParent = parentElement.parentElement;
                selectParent.insertAdjacentElement(
                  'afterend',
                  errorTextElement
                );
              } else {
                parentElement.appendChild(errorTextElement);
              }
            }
            errorTextElement.textContent = errorMessage;
          }

          if (inputField.closest('.meta-upload-file')) {
            const metaUploadFileEl = inputField.closest('.meta-upload-file');
            metaUploadFileEl.classList.add('error');
          }

          inputField.addEventListener('click', () => {
            setTimeout(() => {
              inputField.classList.remove(
                'error',
                ...finalOptions.inputErrorClasses.split(' ')
              );
              form.classList.remove('error');

              if (inputField.closest('.meta-upload-file')) {
                const metaUploadFileEl =
                  inputField.closest('.meta-upload-file');
                metaUploadFileEl.classList.remove('error');
              }

              if (errorTextElement) {
                setTimeout(() => {
                  if (errorTextElement.parentElement) {
                    errorTextElement.parentElement.classList.remove('error');
                  }
                  errorTextElement.remove();
                }, finalOptions.transitionDelay * 2);
              }
            }, finalOptions.errorClearDelay);
          });

          inputField.parentElement.parentElement.addEventListener(
            'click',
            () => {
              setTimeout(() => {
                inputField.parentElement.parentElement.classList.remove(
                  'error'
                );
                form.classList.remove('error');

                if (inputField.closest('.meta-upload-file')) {
                  const metaUploadFileEl =
                    inputField.closest('.meta-upload-file');
                  metaUploadFileEl.classList.remove('error');
                }
              }, finalOptions.errorClearDelay);
            }
          );

          inputField.parentElement.addEventListener('click', () => {
            setTimeout(() => {
              inputField.parentElement.classList.remove('error');
              form.classList.remove('error');

              if (inputField.closest('.meta-upload-file')) {
                const metaUploadFileEl =
                  inputField.closest('.meta-upload-file');
                metaUploadFileEl.classList.remove('error');
              }
            }, finalOptions.errorClearDelay);
          });
        });
      }

      setTimeout(function () {
        const metaCheckboxesArr = document.querySelectorAll('.meta-checkbox');

        metaCheckboxesArr.forEach((checkbox) => {
          checkbox.addEventListener('mouseenter', (e) => {
            checkbox.classList.remove('error');
          });

          checkbox.addEventListener('mousemove', (e) => {
            checkbox.classList.remove('error');
          });
        });
      }, 50);

      const metaCheckboxesArr = document.querySelectorAll('.meta-checkbox');

      function updateAllSimpleBars() {
        document.querySelectorAll('.simplebar-content').forEach((content) => {
          const simpleBarInstance = SimpleBar.instances.get(
            content.closest('[data-simplebar]')
          );
          if (simpleBarInstance) {
            simpleBarInstance.recalculate();
          }
        });
      }
      updateAllSimpleBars();

      return errors;
    } catch (error) {
      console.error('Error parsing JSON data:', error.message);
      return {};
    }
  }
};
